/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Filter_Has_Publish_Date_SetInputs */

const cs_blog_filter_has_publish_date_set = /** @type {(inputs: Blog_Filter_Has_Publish_Date_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Má datum publikace`)
};

const en_blog_filter_has_publish_date_set = /** @type {(inputs: Blog_Filter_Has_Publish_Date_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Has publish date`)
};

/**
* | output |
* | --- |
* | "Has publish date" |
*
* @param {Blog_Filter_Has_Publish_Date_SetInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_filter_has_publish_date_set = /** @type {((inputs?: Blog_Filter_Has_Publish_Date_SetInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Filter_Has_Publish_Date_SetInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_filter_has_publish_date_set(inputs)
	return cs_blog_filter_has_publish_date_set(inputs)
});